import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signout, isAuthenticated, signOutALL } from "../auth";
import './menu.css';
import {
    FaAddressCard, FaSellcast, FaUserAlt, FaUserSlash, FaLongArrowAltLeft,
    FaUserCog, FaBoxes, FaShoppingCart, FaUserSecret, FaMoneyBill,
    FaHandsHelping, FaWallet, FaBuysellads, FaFirstOrder, FaSlidersH, FaLanguage,
    FaBriefcase, FaTruck, FaRoute, FaRobot, FaHeartbeat, FaShieldAlt, FaImages, FaExchangeAlt, FaUserShield
} from "react-icons/fa";
import {
    MdContactPhone, MdClose, MdKeyboardArrowLeft, MdMessage, MdToday, MdEmail,
    MdAccountBox, MdCreateNewFolder, MdPublic, MdCheckBox,
    MdIndeterminateCheckBox, MdAddBusiness, MdLanguage, MdDeleteForever, MdSecurity
} from "react-icons/md";
import { BsGridFill } from "react-icons/bs";
import { AiFillShop } from "react-icons/ai";
import { GrAscend, GrBusinessService, GrSettingsOption } from "react-icons/gr";
import { GiSellCard, GiChessKing, GiFamilyTree } from "react-icons/gi";
import { RiUserCommunityFill } from "react-icons/ri";
import { Family, Adminstrator, Investment, Assoociate, CommercialRole, canAccessMyShop, isSwitchRoleAvailable, isProviderOnlyWorkspace } from "../pageInside/Rolle";
import { buildProviderWorkspace } from "../dropshippingInterne/providerWorkspace";
import { buildSellerSettingsNav } from "../Layout/myBusinessNav";
import { elakayAutoText } from "../pageInside/dataElakay";
import { canAccessSwiperManager, useSwiperAccess } from "../dynamicSwipers/useSwiperAccess";
import RoleSwitchDropdown from "../../components/RoleSwitch/RoleSwitchDropdown";
import useEmailMarketingPermissions from "../pageInside/EmailMarketing/useEmailMarketingPermissions";
import { canSeePermissionCenterLink } from "../permissionCenter/pageAccess";


const { token } = isAuthenticated();


// One permission source for every role, including Family. Do not infer
// Manager access from ownership or another swiper permission.
const SwiperManagerMenuItem = ({ infoSource, label }) => {
    const { loading, access } = useSwiperAccess(infoSource);
    if (loading || !canAccessSwiperManager(access)) return null;
    return (
        <li className="menu-item">
            <Link to="/elakay/swipers" className="menu-link">
                <span className="menu-icon-wrapper">
                    <FaImages className="menu-icon" />
                </span>
                <span className="menu-text">{label}</span>
            </Link>
        </li>
    );
};

const MenuUser = (props) => {
    const chekobj = (ob) => JSON.stringify(ob) === '{}';

    const { infoSource } = props;
    // Email Marketing link: role check first (no request for roles that can
    // never reach it), then the server-resolved Family setting.
    const isCommercialRole = CommercialRole();
    const emailMarketing = useEmailMarketingPermissions({ enabled: isCommercialRole });
    const [simpleUser, setSimpleUser] = useState(true);
    const [Administrator, setAdministrator] = useState(false);
    const [elakayCategory, setelakayCategory] = useState(false);
    
    let classUser = 'menuUserClass open';
    let classAdmin = 'menuAdminClass';

    let ilcod = infoSource.languageAPI.checkLangObjDefault;
    let ileia = !chekobj(infoSource.languageAPI.elakayInfoAPI) && infoSource.languageAPI.elakayInfoAPI;
    let ilei = infoSource.languageAPI.elakayInfo;

    let InfoApiButton = !infoSource.loading && ilcod(ileia, ilei, 'Button');
    let InfoApiMenuList = !infoSource.loading && ilcod(ileia, ilei, 'menuList');
    let InfoApiMenuSertting = !infoSource.loading && ilcod(ileia, ilei, 'menuSertting');

    const menuhande = (setelakayCategory, setSimpleUser, setAdministrator) => {
        setSimpleUser(false);
        setAdministrator(true);
        setelakayCategory(false);
    };

    const backhande = (setelakayCategory, setSimpleUser, setAdministrator) => {
        setSimpleUser(true);
        setAdministrator(false);
        setelakayCategory(false);
    };

    if (Administrator) {
        classUser = 'menuUserClass';
        classAdmin = 'menuAdminClass open';
    }

    if (elakayCategory) {
        classUser = 'menuUserClass';
        classAdmin = 'menuAdminClass open';
    }

    let navigate = useNavigate();

    const HeaderSidebar = () => (
        <div className="headMenuUser">
            
            {!isAuthenticated() && (
                <div className="auth-section">
                    <div className="auth-buttons">
                        <button className="btn-modern btn-signin"
                        onClick={() => navigate('/signin')}
                        >
                            {InfoApiButton.signin}
                        </button>
                        <button className="btn-modern btn-signup"
                        onClick={() => navigate('/signup')}
                        >
                            {InfoApiButton.signup}
                        </button>
                    </div>
                    <div className="user-welcome">
                        <FaUserSlash className="user-icon" />
                        <span className="welcome-text">{InfoApiButton.plSignIN}</span>
                        <button className="btn-close-m" onClick={props.click}>
                            <MdClose />
                        </button>
                    </div>
                </div>
            )}

            {isAuthenticated() && (
                <div className="auth-section authenticated">
                    <div className="auth-buttons">
                        <button
                            className="btn-modern btn-signout"
                            onClick={() => signout(token).then(() => navigate('/signin'))}
                        >
                            {InfoApiButton.signOut}
                        </button>
                        <button
                            className="btn-modern btn-signout-all"
                            onClick={() => signOutALL(token).then(() => navigate('/signin'))}
                        >
                            {InfoApiButton.signOutAll}
                        </button>
                    </div>
                    <div className="user-info">
                        <FaUserAlt className="user-avatar-icon" />
                        <span className="welcome-text">
                            {props.userInfo.lastname + " " + props.userInfo.firstname}
                        </span>
                         <button className="btn-close-m" onClick={props.click}>
                            <MdClose />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );

    const menuSimpleUser = () => (
        simpleUser && (
            <div className={classUser}>
                <ul className="menu-list">


                    {isAuthenticated() && (canAccessMyShop(infoSource) || (infoSource?.individualPermissions || []).length > 0) && (
                        <li className="menu-item settings-item">
                            <Link to="/user-setting" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <FaUserCog className="menu-icon" />
                                </span>
                                <span className="menu-text">{InfoApiMenuList.userSetting}</span>
                            </Link>
                            <button 
                                className="arrow-btn"
                                onClick={() => menuhande(setelakayCategory, setSimpleUser, setAdministrator)}
                            >
                                <MdKeyboardArrowLeft />
                            </button>
                        </li>
                    )}
                    
                    <li className="menu-item">
                        <Link to="/all-catageories" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <BsGridFill className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList.allCategory}</span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/your-step" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <GrAscend className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuSertting.yourStep}</span>
                        </Link>
                    </li>

                    {isAuthenticated() && <li className="menu-item account-settings-menu-item">
                        <Link to="/account/settings" className="menu-link">
                            <span className="menu-icon-wrapper"><FaUserCog className="menu-icon" /></span>
                            <span className="menu-text">{elakayAutoText("h_account_settings", "Account Settings")}</span>
                        </Link>
                    </li>}
                    
                    <li className="menu-item">
                        <Link to="/profile" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaUserSecret className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList.myProfile}</span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/account" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <MdAccountBox className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList.myAccount}</span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/profile?addr=true" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaAddressCard className="menu-icon" />
                            </span>
                            <span className="menu-text">
                                {infoSource.laguangeElakay('Button', infoSource.languageAPI).addAdress}
                            </span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/profile?tel=true" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <MdContactPhone className="menu-icon" />
                            </span>
                            <span className="menu-text">
                                {infoSource.laguangeElakay('Button', infoSource.languageAPI).addTel}
                            </span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/c/orders" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaBoxes className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList.myOrders}</span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/cart" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaShoppingCart className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList.myCart}</span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/deal-today" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <MdToday className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList.todayDeal}</span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/help-contact" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaHandsHelping className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList.helpContact}</span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/purchased" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaMoneyBill className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList.myPurchased}</span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/wallet" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaWallet className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList.wallet}</span>
                        </Link>
                    </li>
                    
                    <li className="menu-item">
                        <Link to="/message" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <MdMessage className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList.myMessage}</span>
                        </Link>
                    </li>

                    {/* Email Inbox (spec §14): same section as My Message --
                        available to every signed-in account (any role can
                        RECEIVE marketing email, unlike sending it). Link stays
                        visible even when unreadEmailCount is 0; the badge
                        beside it only shows once there's something unread. */}
                    <li className="menu-item">
                        <Link to="/email-inbox" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <MdEmail className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuSertting?.emailInbox || elakayAutoText("h_emk_inbox_menu_link", "Email Inbox")}</span>
                            {Number(infoSource?.unreadEmailCount) > 0 && (
                                <span className="menu-badge">{infoSource.unreadEmailCount}</span>
                            )}
                        </Link>
                    </li>

                    {/* <li className="menu-item">
                        <Link to="/contact-requests" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaHandsHelping className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList?.contactRequests || elakayAutoText("h_3f8a1c0d2e5b67", "Contact Requests")}</span>
                        </Link>
                    </li> */}

                    <li className="menu-item">
                        <Link to="/my-job-applications" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaBriefcase className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList?.myJobApplications || elakayAutoText("h_nav_my_job_applications", "Mes candidatures")}</span>
                        </Link>
                    </li>

                    <li className="menu-item">
                        <Link to="/how-we-do-it" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <MdPublic className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList?.howWeDoIt || elakayAutoText("h_hwdi_settings_link", "How We Do It in Elakay")}</span>
                        </Link>
                    </li>
                </ul>
            </div>
        )
    );

    const menuAdmin = () => {
        if (!Administrator) return null;

        const isAssoc = Assoociate();
        const isInvest = Investment();
        const isAdmin = Adminstrator();
        const isFam = Family(props.userInfo.email);
        const showAddRoleGroup = isAssoc || isInvest || isAdmin || isFam;
        const showJobGroup = isFam || isAdmin;
        const showDashboardSettingsGroup = isFam || isAdmin;
        // Provider Center: shown to an effective Provider and to combined roles with Provider access.
        // An effective Provider never gets the Seller My Shop links (they would be refused anyway).
        const providerOnly = isProviderOnlyWorkspace(infoSource);
        const providerItems = buildProviderWorkspace(infoSource);
        // Seller Dropshipping In + External Dropshipping (myBusinessNav.js), already
        // filtered by role and Animation Settings.
        const sellerGroups = buildSellerSettingsNav(infoSource);

        return (
            <div className={classAdmin}>
                <div className="admin-header">
                    <h5 className="admin-title">{InfoApiMenuList.userSetting}</h5>
                    <button
                        className="btn-back"
                        onClick={() => backhande(setelakayCategory, setSimpleUser, setAdministrator)}
                    >
                        <FaLongArrowAltLeft />
                    </button>
                </div>

                <ul className="menu-list admin-menu">
                    {/* ===== Groupe : Boutique ===== */}
                    <li className="menu-section-title">{InfoApiMenuSertting?.groupShop || elakayAutoText("h_05236d3a83691d", "Boutique")}</li>
                    {/* The active role's explicit create switch controls this entry. */}
                    <SwiperManagerMenuItem infoSource={infoSource} label={InfoApiMenuSertting?.swiperManager || elakayAutoText("h_dsw_my_swipers_menu", "My Swipers")} />

                    {!providerOnly && (
                    <li className="menu-item">
                        <Link to="/myshop" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <AiFillShop className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuSertting.myShop}</span>
                        </Link>
                    </li>
                    )}

                    {!providerOnly && (<>
                    <li className="menu-item">
                        <Link to="/myshop?sel=true" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaSellcast className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuSertting.sell}</span>
                        </Link>
                    </li>

                    <li className="menu-item">
                        <Link to="/myshop?trash=1" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <MdDeleteForever className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuSertting?.trash || elakayAutoText("h_nav_trash", "Trash")}</span>
                        </Link>
                    </li>

                    <li className="menu-item">
                        <Link to="/myshop?mb=true&BPUB=false" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <MdPublic className="menu-icon" />
                            </span>
                            <span className="menu-text">
                                {infoSource.language(infoSource, 'title', 'myShopPub')}
                            </span>
                        </Link>
                    </li>

                    <li className="menu-item">
                        <Link to="/myshop?odr=true" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaFirstOrder className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuSertting.buyerCustomer}</span>
                        </Link>
                    </li>

                    <li className="menu-item">
                        <Link to="/myshop?td=true" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <MdCheckBox className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuSertting.yourProInDeal}</span>
                        </Link>
                    </li>

                    <li className="menu-item">
                        <Link to="/myshop?fd=true" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <MdIndeterminateCheckBox className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuSertting.yourProOutDeal}</span>
                        </Link>
                    </li>
                    </>)}

                    <li className="menu-item">
                        <Link to="/delivery" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaTruck className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuSertting?.delivery || elakayAutoText("h_0607f96ff977ca", "Centre de livraison")}</span>
                        </Link>
                    </li>

                    <li className="menu-item">
                        <Link to="/postman?scan=1" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaRoute className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuSertting?.postman || elakayAutoText("h_02ef700b51bdf5", "Livreur / Postman")}</span>
                        </Link>
                    </li>

                    {/* Email Marketing (spec §3): minimum role is Seller, not Family --
                        assertEmailMarketingPermission on the server remains the real
                        gate, this is just discoverability in the account menu. Hidden
                        (not just disabled) when Settings deny this role access. */}
                    {isCommercialRole && emailMarketing.access.canAccessEmailMarketing && (
                        <li className="menu-item">
                            <Link to="/elakay/email-marketing-dashboard" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <MdMessage className="menu-icon" />
                                </span>
                                <span className="menu-text">{InfoApiMenuSertting?.emailMarketingDashboard || elakayAutoText("h_emk_menu_dashboard_link", "Email Marketing")}</span>
                            </Link>
                        </li>
                    )}
                    {sellerGroups.map((group) => (
                        <React.Fragment key={`seller-group-${group.key}`}>
                            <li className="menu-section-title">{group.title}</li>
                            {group.items.map((item) => {
                                const Icon = item.icon;
                                return (
                                    <li className="menu-item" key={`seller-${item.key}`}>
                                        {item.status === "active" ? (
                                            <Link to={item.route} className="menu-link">
                                                <span className="menu-icon-wrapper"><Icon className="menu-icon" /></span>
                                                <span className="menu-text">{item.label}</span>
                                            </Link>
                                        ) : (
                                            <span className="menu-link" aria-disabled="true">
                                                <span className="menu-icon-wrapper"><Icon className="menu-icon" /></span>
                                                <span className="menu-text">{item.label} ({item.statusText})</span>
                                            </span>
                                        )}
                                    </li>
                                );
                            })}
                        </React.Fragment>
                    ))}
                    {providerItems.length > 0 && (
                        <>
                            <li className="menu-section-title">{elakayAutoText("h_pvc_menu_group", "Provider Center")}</li>
                            {providerItems.map((item) => {
                                const Icon = item.icon;
                                return (
                                    <li className="menu-item" key={`provider-${item.key}`}>
                                        {item.status === "active" ? (
                                            <Link to={item.route} className="menu-link">
                                                <span className="menu-icon-wrapper"><Icon className="menu-icon" /></span>
                                                <span className="menu-text">{item.label}</span>
                                            </Link>
                                        ) : (
                                            <span className="menu-link" aria-disabled="true">
                                                <span className="menu-icon-wrapper"><Icon className="menu-icon" /></span>
                                                <span className="menu-text">{item.label} ({elakayAutoText("h_pvc_soon", "Soon")})</span>
                                            </span>
                                        )}
                                    </li>
                                );
                            })}
                        </>
                    )}
                    {isAuthenticated() && isSwitchRoleAvailable(infoSource) && (
                        <>
                            {/* Switch Role / View As Role (Phase 1) -- always-visible
                                checkbox list, NOT a dropdown/modal (that behavior is
                                reserved for the desktop Header menu). Visible ONLY to
                                Associate..Family real accounts (isSwitchRoleAvailable) --
                                Seller/Provider/Royalty/User never see this section at
                                all, not even an empty title. */}
                            <li className="menu-section-title">{elakayAutoText("roleSwitch_menuLabel", "Switch Role")}</li>
                            <li className="role-switch-menu-slot">
                                <RoleSwitchDropdown infoSource={infoSource} mode="list" />
                            </li>
                        </>
                    )}
                    {/* ===== Groupe : Investissement ===== */}
                    <li className="menu-section-title">{InfoApiMenuSertting?.groupInvestment || elakayAutoText("h_ba3f6f4e01baf2", "Investissement")}</li>

                    <li className="menu-item">
                        <Link to="/investments" className="menu-link">
                            <span className="menu-icon-wrapper">
                                <FaMoneyBill className="menu-icon" />
                            </span>
                            <span className="menu-text">{InfoApiMenuList?.investments || elakayAutoText("h_6de8d2a27f2c4c", "Investments")}</span>
                        </Link>
                    </li>

                    {isFam && (
                        <li className="menu-item">
                            <Link to="/elakay/investments-dashboard" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <FaMoneyBill className="menu-icon" />
                                </span>
                                <span className="menu-text">{InfoApiMenuList?.investmentDashboard || elakayAutoText("h_dd976b0931125e", "Investment Dashboard")}</span>
                            </Link>
                        </li>
                    )}

                    {/* ===== Groupe : Ajouter un rôle ===== */}
                    {showAddRoleGroup && (
                        <li className="menu-section-title">{InfoApiMenuSertting?.groupAddRole || elakayAutoText("h_ae3dfa775f6ceb", "Ajouter un rôle")}</li>
                    )}

                    {isAssoc && (
                        <>
                            <li className="menu-item">
                                <Link to='/admin_associat' className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <RiUserCommunityFill className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting.viewUser}</span>
                                </Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/admin_associat?page=usersAdd&usel=1" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <GiChessKing className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting.addUserRoyalty}</span>
                                </Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/admin_associat?page=usersAdd&usel=2" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <FaBuysellads className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting.addSeller}</span>
                                </Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/admin_associat?page=usersAdd&usel=3" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <GiSellCard className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting.addProducer}</span>
                                </Link>
                            </li>
                        </>
                    )}

                    {isInvest && (
                        <li className="menu-item">
                            <Link to="/admin_associat?page=usersAdd&usel=4" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <GrBusinessService className="menu-icon" />
                                </span>
                                <span className="menu-text">{InfoApiMenuSertting.addAssociate}</span>
                            </Link>
                        </li>
                    )}

                    {isAdmin && (
                        <li className="menu-item">
                            <Link to="/admin_associat?page=usersAdd&usel=5" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <MdAddBusiness className="menu-icon" />
                                </span>
                                <span className="menu-text">{InfoApiMenuSertting.addInvestment}</span>
                            </Link>
                        </li>
                    )}

                    {isFam && (
                        <>
                            <li className="menu-item">
                                <Link to="/admin_associat?page=usersAdd&usel=6" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <FaUserCog className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting.addAdministrator}</span>
                                </Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/admin_associat?page=usersAdd&usel=7" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <GiFamilyTree className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting.addFamilly}</span>
                                </Link>
                            </li>
                        </>
                    )}

                    {/* ===== Groupe : Emplois ===== */}
                    {showJobGroup && (
                        <li className="menu-section-title">{InfoApiMenuSertting?.groupJob || elakayAutoText("h_543827f723b8c9", "Emplois")}</li>
                    )}

                    {isFam && (
                        <li className="menu-item">
                            <Link to="/elakay/job-dashboard" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <FaBriefcase className="menu-icon" />
                                </span>
                                <span className="menu-text">{InfoApiMenuSertting?.jobDashboard || elakayAutoText("h_c348d1bada604a", "Job Dashboard")}</span>
                            </Link>
                        </li>
                    )}

                    {isAdmin && (
                        <li className="menu-item">
                            <Link to="/elakay/job-positions" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <FaBriefcase className="menu-icon" />
                                </span>
                                <span className="menu-text">{InfoApiMenuSertting?.jobPositionsAdmin || elakayAutoText("h_956ac88d63a67a", "Liste des postes")}</span>
                            </Link>
                        </li>
                    )}

                    {/* ===== Groupe : Tableaux de bord et Paramètres ===== */}
                    {showDashboardSettingsGroup && (
                        <li className="menu-section-title">{InfoApiMenuSertting?.groupDashboardSettings || elakayAutoText("h_0eec411ef96874", "Tableaux de bord et Paramètres")}</li>
                    )}

                    {isFam && (
                        <li className="menu-item">
                            <Link to="/elakay/how-we-do-it-dashboard" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <GrBusinessService className="menu-icon" />
                                </span>
                                <span className="menu-text">{InfoApiMenuSertting?.howWeDoItDashboard || elakayAutoText("h_hwdi_settings_dashboard_link", "How We Do It in Elakay Dashboard")}</span>
                            </Link>
                        </li>
                    )}

                    {isFam && (
                        <li className="menu-item">
                            <Link to="/elakay-language" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <MdLanguage className="menu-icon" />
                                </span>
                                <span className="menu-text">{InfoApiMenuSertting.addLanguage}</span>
                            </Link>
                        </li>
                    )}

                    {isFam && (
                        <>
                            <li className="menu-item">
                                <Link to="/traductor-team" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <FaLanguage className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting.addTeanTraductor}</span>
                                </Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/category" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <MdCreateNewFolder className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting.creatCatalog}</span>
                                </Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/filters" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <FaSlidersH className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting.creatFilter}</span>
                                </Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/elakay/Settings" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <GrSettingsOption className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting?.AnimationSettings || elakayAutoText("h_9a51d2cdabc34a", "Font & Animation Settings")}</span>
                                </Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/elakay/Settings/email-marketing" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <MdMessage className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting?.emailMarketingSettings || elakayAutoText("h_emk_menu_settings_link", "Email Marketing Settings")}</span>
                                </Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/elakay/chatbot-dashboard" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <FaRobot className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting?.chatbotDashboard || elakayAutoText("h_7c2f6a1e9b3d44", "Chatbot Dashboard")}</span>
                                </Link>
                            </li>
                        </>
                    )}

                    {isAdmin && (
                        <li className="menu-item">
                            <Link to="/pageBuilder" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <GrSettingsOption className="menu-icon" />
                                </span>
                                <span className="menu-text">{InfoApiMenuSertting?.pageBuilder || elakayAutoText("h_f29aa6896ad555", "Page Studio")}</span>
                            </Link>
                        </li>
                    )}

                    {/* ===== Groupe : Finance (Family only) ===== */}
                    {isFam && (
                        <>
                            <li className="menu-section-title">{InfoApiMenuSertting?.groupFinance || elakayAutoText("h_tc_menu_group", "Finance")}</li>
                            <li className="menu-item">
                                <Link to="/elakay/transaction-center" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <FaExchangeAlt className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting?.transactionCenter || elakayAutoText("h_tc_menu_link", "Transaction Center")}</span>
                                </Link>
                            </li>
                        </>
                    )}

                    {/* ===== Groupe : Système ===== */}
                    {isFam && (
                        <>
                            <li className="menu-section-title">{InfoApiMenuSertting?.groupSystem || elakayAutoText("h_62d095204ed2fb", "Système")}</li>
                            <li className="menu-item">
                                <Link to="/elakay/system-health" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <FaHeartbeat className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting?.systemHealth || elakayAutoText("h_bd51a1b68ef644", "System Health")}</span>
                                </Link>
                            </li>
                        </>
                    )}

                    {/* ===== Groupe : Sécurité ===== */}
                    {isFam && (
                        <>
                            <li className="menu-section-title">{InfoApiMenuSertting?.groupSecurity || elakayAutoText("h_33e96f02748f10", "Sécurité")}</li>
                            <li className="menu-item">
                                <Link to="/elakay/security-center" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <FaShieldAlt className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting?.securityCenter || elakayAutoText("h_fd1b86513ea1a7", "Security Center")}</span>
                                </Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/elakay/Settings/monitoring" className="menu-link">
                                    <span className="menu-icon-wrapper">
                                        <MdSecurity className="menu-icon" />
                                    </span>
                                    <span className="menu-text">{InfoApiMenuSertting?.monitoringSettings || elakayAutoText("h_eca144b0213327", "Monitoring & Security Settings")}</span>
                                </Link>
                            </li>
                        </>
                    )}

                    {/* ===== Permission Center (owner / real Family role, even under Switch Role) ===== */}
                    {canSeePermissionCenterLink(infoSource) && (
                        <li className="menu-item">
                            <Link to="/elakay/permission-center" className="menu-link">
                                <span className="menu-icon-wrapper">
                                    <FaUserShield className="menu-icon" />
                                </span>
                                <span className="menu-text">{elakayAutoText("h_perm_title", "Elakay Permission Center")}</span>
                            </Link>
                        </li>
                    )}
                </ul>
            </div>
        );
    };

    return (
        <div className="nemuUserContainer">
            {HeaderSidebar()}
            <div className="numeUserpage">
                {menuSimpleUser()}
                {menuAdmin()}
            </div>
        </div>
    );
};

export default MenuUser;
